// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___298cfaf4a88b8d4cd05","cls2":"Comments-cls2___c691ac752d9d55a71bf Comments-cls1___298cfaf4a88b8d4cd05"};